import { render, staticRenderFns } from "./PortalAlertsCard.vue?vue&type=template&id=3c7a744a&scoped=true&"
import script from "./PortalAlertsCard.vue?vue&type=script&lang=js&"
export * from "./PortalAlertsCard.vue?vue&type=script&lang=js&"
import style0 from "./PortalAlertsCard.vue?vue&type=style&index=0&id=3c7a744a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7a744a",
  null
  
)

export default component.exports